import { TweenBase } from "../base";
import { Lights } from ".";
import * as TWEEN from "@tweenjs/tween.js";

/**
 * class: FaceInTween
 */
export class FaceInTween extends TweenBase {
	private _container: HTMLElement;
	constructor(container: HTMLElement) {
		super({ x: 0.0001, y: 0 }, { x: 1.0, y: 1500 });
		this._container = container;
		this.duration = 1500;
		this.easing = TWEEN.Easing.Quadratic.InOut;
	}
	public prepare(): TWEEN.Tween {
		// var scope: any = this;
		return super.prepare().onUpdate(function () {
			this._container.style.opacity = this.from['x'].toString();
		})
			.onComplete(function () {
				;
			});
	} // to override.
}

/**
 * class: TimeLapseTween
 */
export class TimeLapseTween extends TweenBase {
	private _lights: Lights;
	constructor(lights: Lights, from: {}, to: {}) {
		super(from, to);
		this.duration = 3000;
		this._lights = lights;
	}
	public prepare(): TWEEN.Tween {
		// var scope = this;
		return super.prepare().onUpdate(function () {
			this._lights.apply(this.from);
		})
			.onComplete(function () {
				;
			});
	} // to override.
}
